import React from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';

const createMarkup = (html) => {
  return {__html: html};
};

const MarkUp = ({ html }) => {
  return <div dangerouslySetInnerHTML={createMarkup(html)} />;
};

MarkUp.propTypes = {
  html: PropTypes.string
};

export default MarkUp;